import { Component } from "react";
import PageError from "../../pages/error/PageError";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  resetError = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return <PageError onReset={this.resetError} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
